import { msg } from '@gonfalon/messages/msg';

import { VALID_ANALYSIS_PERCENTILES } from './constants';
import type { EVENT_LEVEL_UNIT_AGGREGATION_TYPE } from './eventLevelPercentile';
import { isEventLevelPercentileMetric, isValidEventLevelPercentile } from './eventLevelPercentile';
import type { Metric } from './types';

export function getAnalysisTypeDisplayName(
  analysisType: Metric['analysisType'],
  percentileValue?: number,
  unitAggregationType?: Metric['unitAggregationType'] | typeof EVENT_LEVEL_UNIT_AGGREGATION_TYPE,
): string {
  if (analysisType === 'mean') {
    return msg('metrics.definitionSummary.average');
  } else if (analysisType === 'percentile' && percentileValue !== undefined) {
    const isValidPercentile = isEventLevelPercentileMetric({ unitAggregationType })
      ? isValidEventLevelPercentile(percentileValue)
      : VALID_ANALYSIS_PERCENTILES.includes(percentileValue);
    if (isValidPercentile) {
      return msg('metrics.definitionSummary.percentile', { value: percentileValue });
    }
  }
  return 'undefined';
}
